import { XIcon } from "@libs/zapi-ui/assets";
import { AppButton } from "@libs/zapi-ui/custom";
import { cancelGeneration, useClaimsStoreSelector, selectIsCancelling, selectGenerationId } from "../model/store";

export function CancelClaimsAnalysis({ chapterId }: { chapterId: string | undefined }) {
  const isCancelling = useClaimsStoreSelector(selectIsCancelling(chapterId));
  const generationId = useClaimsStoreSelector(selectGenerationId(chapterId));

  const handleCancel = async () => {
    if (!chapterId) return;
    await cancelGeneration(chapterId);
  };

  return (
    <div>
      <AppButton
        startAdornment={<XIcon className="w-4 h-4" />}
        size="sm"
        appearance="text"
        onClick={handleCancel}
        isLoading={isCancelling}
        disabled={!generationId}
      >
        Cancel
      </AppButton>
    </div>
  );
}
